<template>
  <v-container>
    <div class="mb-4">
      <div><h2 class="mb-3">Поиск мероприятий</h2></div>
      <div>
        В данном разделе можно узнать, в каких треках и каких компетенциях
        состоит мероприятие.
      </div>

      <form action="#" @submit.prevent="handleSubmit">
        <v-row class="mt-3 mb-3 align-start" align-start>
          <v-col cols="12" sm="12" md="10">
            <v-text-field
              v-model="form.search"
              label="Поиск мерприятия по ID или по названию"
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="2">
            <v-btn
              x-large
              block
              color="primary"
              :loading="pending"
              type="submit"
            >
              Найти
            </v-btn>
          </v-col>
        </v-row>
      </form>

      <div>
        <div v-for="event in list" :key="event.id">
          <event-card
            :id="event.id"
            :title="event.title"
            :start="event.start"
            :end="event.end"
            :address="event.address"
            :settings="event.settings"
            :draft="event.draft"
          ></event-card>
        </div>
      </div>
    </div>

    <app-pager
      :value="form.page"
      :total="total"
      :limit="size"
      :pending="pending"
      @input="setPage"
    ></app-pager>
  </v-container>
</template>

<script>
import { apiClient } from "@/api";
import { TALENT_API_V2_URL } from "@/constants";
import { unPaginateApiRequest } from "@/utils";
import { combineEventsSettings } from "./utils";
import { EventCard } from "@/components/search";

const EVENTS_PER_PAGE = 20;

export default {
  name: "EventSearch",
  components: {
    EventCard,
  },
  data() {
    return {
      form: {
        search: "",
        page: 1,
      },
      pending: false,
      events: [],
      eventsSettings: {},
      total: 0,
      size: EVENTS_PER_PAGE,
    };
  },
  computed: {
    list() {
      const { events, eventsSettings } = this;
      if (!events) {
        return [];
      }
      return events.map((event) => {
        const settings = eventsSettings[event.id] || [];

        return {
          ...event,
          settings,
        };
      });
    },
  },
  watch: {
    "$route.query": {
      handler(val, prev) {
        const { search, page } = val;
        if (prev && prev.search !== search) {
          this.form.page = 1;
        } else {
          this.form.page = parseInt(page) || 1;
        }
        this.form.search = search;
        // Reset offset on new
        if (search) {
          this.handleSearch();
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    setPage(page) {
      this.form.page = page;
      this.handleSubmit();
    },
    handleSubmit() {
      this.$router.push({
        query: {
          ...this.form,
        },
      });
      this.handleSearch();
    },
    async handleSearch() {
      const { search, page = 1 } = this.form;
      const offset = (page - 1) * EVENTS_PER_PAGE;
      this.pending = true;
      const isIntOnlyInput =
        Number.isInteger(parseFloat(search)) &&
        String(parseFloat(search)) === search;
      const payload = {
        limit: this.size,
        offset,
      };
      if (isIntOnlyInput) {
        payload.event_id = search;
      } else {
        payload.search = search;
      }
      try {
        // Получаем список мероприятий в таланте
        const { data, headers } = await apiClient({
          method: "GET",
          url: "/events",
          baseURL: TALENT_API_V2_URL,
          params: payload,
        });

        const ids = data.map((n) => n.id);

        this.eventsSettings = combineEventsSettings(
          await unPaginateApiRequest({
            method: "GET",
            url: "/events/settings",
            baseURL: process.env.VUE_APP_API_URL,
            params: { event_ids: ids.join() },
          })
        );
        this.events = data ?? [];
        this.total = parseInt(headers["x-count"]) || data.length;
      } catch (error) {
        this.pending = false;
        if (error instanceof Error) {
          this.$toast.error(error.message);
        } else {
          this.$toast.error("Произошла ошибка при поиске мероприятий");
        }
        console.error("Error during search:", error);
        return;
      }
      this.pending = false;
    },
    async init() {
      const requests = [
        this.$store.dispatch("talent/getAllAchievementRoles"),
        this.$store.dispatch("getAllGroups"),
        this.$store.dispatch("getAllTracks"),
        this.$store.dispatch("getAllCompetence"),
        this.$store.dispatch("getAllCompTracks"),
      ];

      await Promise.all(requests);
    },
  },
};
</script>

<style></style>
